import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/auth/auth';
import { AutoRefreshSettingsService } from '../../services/auto-refresh-settings.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: false,
})
export class HeaderComponent implements OnInit {
  public initials: string = '';

  public userProfile: Record<string, string> = {};

  constructor(
    private readonly authService: AuthService,
    public readonly themeService: ThemeService,
    public readonly autoRefreshSettings: AutoRefreshSettingsService
  ) {}

  public ngOnInit(): void {
    // this.authService.userProfile$.subscribe((res) => {
    //   if (Object.keys(res).length > 0) {
    //     this.initials = res?.picture || '';
    //     this.userProfile['name'] = res?.name;
    //     this.userProfile['email'] = res?.email;
    //   }
    // });
    this.authService.user$.subscribe(user => {
       this.userProfile['name'] = user?.name || '';
        this.userProfile['email'] = user?.email || '';
});
  }

  public getInitials(name: string): string {
    const nameParts: string[] = name?.trim()?.split(/\s+/).filter(Boolean);
    if (nameParts.length === 1) {
      return nameParts[0][0].toUpperCase().repeat(2);
    }
    return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
  }

  public signOut(): void {
    localStorage.clear();
    this.authService.logout();
  }
}
